import React from 'react';
import PropTypes from 'prop-types';

import { fromJS } from 'immutable';
import ItemField from '../../../Components/ItemField/ItemField';
import withToggleView from '../../../Components/ToggleView/ToggleView';

const BlockPackages = ({ product, strings, id }) => {
  const {packages} = product

  const contentViewBlock = Array.isArray(packages)
    ? packages.map(p => (

            <div className="package" key={`${p.code}-${p.id}`}>
              <div className="group name">
                <ItemField
                  label={strings['product.block.package.field.rec_name.label'] || 'Nom'}
                  value={p.name}
                  name="rec_name"
                  optional
                />
              </div>
            </div>
          )
    )
    : undefined;

  return (
    <div className="content" key={id}>
      {contentViewBlock}
    </div>
  );
};

BlockPackages.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strings: PropTypes.objectOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  product: PropTypes.object
};

BlockPackages.defaultProps = {
  product: {},
  strings: fromJS({}),
};

const config = {
  title: 'product.block.packages.title',
  defaultTitle: 'Packages',
  name: 'packages',
  active: false,
};

export default withToggleView(BlockPackages, config);
